import React, { useState } from "react";
import axios from "axios";
import { Card, Form, Button, Alert, Spinner, Container } from "react-bootstrap";
import { CONFIG } from "../utils/config";

// Official Government/Corporate Colors
const GOV_BLUE = "#002347"; // Deep Ministry Blue
const GRADIENT_START = "#004e92"; 
const GRADIENT_END = "#000428"; 

function LoginScreen({ onLogin }) {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const attemptLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    setTimeout(async () => {
      try {
        const res = await axios.post(`${CONFIG.AUTH_BASE}/login`, formData);
        localStorage.setItem("bsnl_user", JSON.stringify(res.data));
        onLogin(res.data);
      } catch (err) {
        // Fallback for demo/testing
        if (formData.username === 'admin' && formData.password === 'password123') {
            const demoUser = { username: "NSFDC Admin", role: "admin" };
            localStorage.setItem("bsnl_user", JSON.stringify(demoUser));
            onLogin(demoUser);
        } else {
            setError("Authentication Failed. Invalid User ID or Password.");
        }
      } finally { setLoading(false); }
    }, 800);
  };

  return (
    <div className="d-flex flex-column min-vh-100" style={{ backgroundColor: "#f5f7fa", fontFamily: "'Segoe UI', sans-serif" }}>
      
      {/* 1. TOP GOV STRIP */}
      <div style={{ background: "#f1f1f1", borderBottom: "1px solid #ddd", fontSize: "0.8rem" }}>
        <Container fluid className="py-1 px-4 d-flex justify-content-between align-items-center text-dark">
            <span><strong>Government of India</strong> | Ministry of Social Justice and Empowerment</span>
        </Container>
      </div>

      {/* 2. BRANDING HEADER */}
      <div className="bg-white shadow-sm border-bottom py-2">
        <Container fluid className="px-4">
            <div className="d-flex flex-wrap align-items-center justify-content-center gap-3">
                {/* LOGO */}
                <img 
                    src="https://ik.imagekit.io/nanoplex/Project%20Image/NSFDC/nsfdclogo-removebg-preview_aCQYROM-P.png?updatedAt=1763554348489" 
                    alt="NSFDC Logo" 
                    style={{ height: "80px", width: "auto" }} 
                />
                <div className="lh-sm border-start ps-3 border-2 border-secondary">
                    <h4 className="fw-bold m-0" style={{ color: GOV_BLUE }}>NATIONAL SCHEDULED CASTES FINANCE AND DEVELOPMENT CORPORATION</h4>
                    <small className="text-secondary fw-bold" style={{ fontSize: "0.8rem", letterSpacing: "0.5px" }}>
                        NSFDC SMS Portal
                    </small>
                </div>
            </div>
        </Container>
      </div>

      {/* 3. GRADIENT STRIP */}
      <div style={{ height: "6px", background: `linear-gradient(to right, ${GRADIENT_START}, ${GRADIENT_END})` }}></div>

      {/* 4. MAIN CONTENT AREA */}
      <Container className="flex-grow-1 d-flex justify-content-center align-items-center py-5">
        <Card className="shadow-sm border" style={{ width: "100%", maxWidth: "420px", borderRadius: "4px" }}>
          
          {/* Card Header - Official Blue */}
          <div className="text-white text-center py-3" style={{ backgroundColor: GOV_BLUE, borderTopLeftRadius: "4px", borderTopRightRadius: "4px" }}>
            <h5 className="mb-0 fw-bold"><i className="bi bi-lock-fill me-2"></i>SMS GATEWAY LOGIN</h5>
            <small style={{ opacity: 0.8 }}>Authorized Access Only</small>
          </div>

          <Card.Body className="p-4 bg-white">
            {error && (
                <Alert variant="danger" className="py-2 px-3 small border-danger">
                    <i className="bi bi-exclamation-octagon-fill me-2"></i>{error}
                </Alert>
            )}

            <Form onSubmit={attemptLogin}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold text-secondary" style={{fontSize: "0.85rem"}}>USER ID</Form.Label>
                <div className="input-group">
                    <span className="input-group-text bg-light"><i className="bi bi-person-fill"></i></span>
                    <Form.Control 
                        type="text"
                        placeholder="Enter Username" 
                        value={formData.username}
                        onChange={e => setFormData({...formData, username: e.target.value})}
                        required 
                        className="rounded-0 rounded-end"
                        style={{ fontSize: "0.9rem" }}
                    />
                </div>
              </Form.Group>
              
              <Form.Group className="mb-4">
                <Form.Label className="fw-bold text-secondary" style={{fontSize: "0.85rem"}}>PASSWORD</Form.Label>
                <div className="input-group">
                    <span className="input-group-text bg-light"><i className="bi bi-key-fill"></i></span>
                    <Form.Control 
                        type="password" 
                        placeholder="Enter Password"
                        value={formData.password}
                        onChange={e => setFormData({...formData, password: e.target.value})}
                        required 
                        className="rounded-0 rounded-end"
                        style={{ fontSize: "0.9rem" }}
                    />
                </div>
              </Form.Group>

              <Button type="submit" className="w-100 fw-bold py-2 rounded-1" disabled={loading} style={{ backgroundColor: "#1c5b8e", borderColor: "#1c5b8e" }}>
                {loading ? <><Spinner animation="border" size="sm" className="me-2" /> Authenticating...</> : "SECURE LOGIN"}
              </Button>
            </Form>

            <div className="text-center mt-3">
                {/* FIXED: Replaced invalid <a> tag with styled <button> */}
                <button 
                    className="btn btn-link text-decoration-none text-muted p-0 border-0" 
                    style={{ fontSize: "0.85rem", boxShadow: "none" }}
                    onClick={() => alert("Please contact the IT Administrator to reset your credentials.")}
                >
                    Forgot Password / User ID?
                </button>
            </div>
          </Card.Body>
          
          <Card.Footer className="bg-light text-center py-2">
             <small className="text-muted d-block" style={{fontSize: "0.7rem"}}>
                <i className="bi bi-shield-check me-1"></i>System access is monitored for security purposes.
             </small>
          </Card.Footer>
        </Card>
      </Container>

      {/* 5. FOOTER */}
      <footer className="bg-dark text-white py-3 text-center border-top border-3 border-secondary">
        <Container>
            <p className="mb-1 small" style={{ opacity: 0.8 }}>© 2026 National Scheduled Castes Finance and Development Corporation. All Rights Reserved.</p>
            <p className="mb-0 small fw-bold">Managed by NSFDC IT Department <i className="bi bi-cpu-fill ms-1"></i></p>
        </Container>
      </footer>
    </div>
  );
}

export default LoginScreen;